import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const WHATSAPP_URL = "https://wa.me/5547992561262?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento.";

const SERVICES_DETAILED = [
  {
    icon: "ri-draft-line",
    title: "Projetos para Construção",
    img: "https://readdy.ai/api/search-image?query=architectural%20blueprints%20technical%20drawings%20construction%20plans%20professional%20engineering%20documents%20detailed%20floor%20plans%20white%20desk%20modern%20office%20clean%20design%20high%20quality%20photography&width=700&height=480&seq=svc1&orientation=landscape",
    desc: "Elaboramos projetos arquitetônicos completos, incluindo projetos estruturais, hidráulicos, elétricos e complementares. Nossa equipe técnica garante que todos os projetos atendam às normas vigentes (ABNT, CREA, CAU) e às exigências da prefeitura local.",
    items: [
      "Projeto Arquitetônico",
      "Projeto Estrutural",
      "Projeto Hidrossanitário",
      "Projeto Elétrico",
      "Memorial Descritivo",
      "Alvará de Construção",
    ],
  },
  {
    icon: "ri-government-line",
    title: "Regularização de Construções",
    img: "https://readdy.ai/api/search-image?query=official%20documents%20building%20permits%20legal%20paperwork%20property%20registration%20architecture%20office%20professional%20setting%20organized%20documents%20desk%20clean%20modern%20environment&width=700&height=480&seq=svc2&orientation=landscape",
    desc: "Regularizamos construções existentes junto aos órgãos municipais, estaduais e federais competentes. Desde levantamentos topográficos até a emissão do Habite-se, cuidamos de toda a documentação necessária.",
    items: [
      "Levantamento da Edificação",
      "Projeto de Regularização",
      "Processo na Prefeitura",
      "Averbação no Cartório",
      "Habite-se",
      "Consultoría Jurídica",
    ],
  },
  {
    icon: "ri-sofa-line",
    title: "Design de Interiores",
    img: "https://readdy.ai/api/search-image?query=luxury%20modern%20interior%20design%20living%20room%20sophisticated%20furniture%20elegant%20lighting%20minimalist%20decor%20contemporary%20high%20end%20residential%20interior%20magazine%20quality%20photography&width=700&height=480&seq=svc3&orientation=landscape",
    desc: "Criamos ambientes funcionais, estéticos e personalizados que refletem a personalidade e o estilo de vida de cada cliente. Do conceito à execução, acompanhamos todo o processo para garantir o resultado perfeito.",
    items: [
      "Projeto de Layout",
      "Seleção de Materiais",
      "Projeto Luminotécnico",
      "Projeto de Marcenaria",
      "Gestão de Fornecedores",
      "Acompanhamento de Obra",
    ],
  },
  {
    icon: "ri-home-gear-line",
    title: "Design de Fachadas",
    img: "https://readdy.ai/api/search-image?query=modern%20building%20facade%20renovation%20contemporary%20exterior%20design%20architectural%20cladding%20beautiful%20residential%20facade%20upgrade%20modern%20materials%20professional%20architecture%20photography&width=700&height=480&seq=svc4&orientation=landscape",
    desc: "Desenvolvemos fachadas modernas e impactantes que valorizam seu imóvel e reforçam sua identidade visual. Trabalhamos com os melhores materiais e acabamentos para garantir durabilidade e beleza.",
    items: [
      "Conceito Visual da Fachada",
      "Projeto Executivo",
      "Especificação de Materiais",
      "Compatibilização Estrutural",
      "Renderização 3D",
      "Acompanhamento de Execução",
    ],
  },
  {
    icon: "ri-3d-cube-sphere-line",
    title: "Maquetes Eletrônicas",
    img: "https://readdy.ai/api/search-image?query=3d%20architectural%20visualization%20render%20luxury%20modern%20house%20photorealistic%20rendering%20beautiful%20exterior%20high%20quality%20architectural%203d%20rendering%20professional%20visualization%20impressive&width=700&height=480&seq=svc5&orientation=landscape",
    desc: "Criamos visualizações 3D fotorrealistas que permitem ver e experimentar o projeto antes mesmo de iniciar a obra. Uma poderosa ferramenta para tomada de decisões e aprovação de projetos.",
    items: [
      "Modelagem 3D",
      "Render Fotorrealista",
      "Tour Virtual 360°",
      "Animação Arquitetônica",
      "Apresentação para Clientes",
      "Revisões Ilimitadas",
    ],
  },
  {
    icon: "ri-bank-line",
    title: "Financiamento de Imóveis",
    img: "https://readdy.ai/api/search-image?query=financial%20consultation%20real%20estate%20investment%20professional%20meeting%20modern%20office%20financial%20documents%20property%20financing%20business%20meeting%20professional%20setting%20high%20quality&width=700&height=480&seq=svc6&orientation=landscape",
    desc: "Oferecemos assessoria completa para financiamento imobiliário, auxiliando nossos clientes a encontrar as melhores condições de financiamento junto às principais instituições financeiras do país.",
    items: [
      "Análise de Crédito",
      "Simulação de Financiamento",
      "Documentação Completa",
      "Acompanhamento do Processo",
      "Negociação com Bancos",
      "Orientação Jurídica",
    ],
  },
];

const PROCESS = [
  { step: "01", icon: "ri-chat-3-line", title: "Consulta Inicial", desc: "Entre em contato e compartilhe suas ideias e necessidades." },
  { step: "02", icon: "ri-draft-line", title: "Elaboração do Projeto", desc: "Nossa equipe desenvolve o projeto completo com todos os detalhes." },
  { step: "03", icon: "ri-check-double-line", title: "Aprovação e Ajustes", desc: "Apresentamos o projeto para sua aprovação com ajustes necessários." },
  { step: "04", icon: "ri-building-2-line", title: "Execução e Entrega", desc: "Acompanhamos a execução até a entrega final com qualidade garantida." },
];

export default function Servicos() {
  return (
    <main>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-24 overflow-hidden" style={{ backgroundColor: "#1F1F1F" }}>
        <div className="absolute inset-0 opacity-5">
          <img
            src="https://readdy.ai/api/search-image?query=engineering%20technical%20blueprint%20pattern%20architectural%20lines%20dark%20background%20abstract%20technical%20drawing&width=1920&height=600&seq=svcHero&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <span className="text-[#C9A24A] text-xs font-semibold tracking-widest uppercase mb-4 block">O que fazemos</span>
          <h1 className="text-white font-bold text-5xl md:text-6xl mb-5 leading-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Nossos Serviços
          </h1>
          <div className="w-16 h-1 mx-auto bg-[#C9A24A] mb-6" />
          <p className="text-white/80 text-lg max-w-2xl mx-auto leading-relaxed">
            Soluções completas em engenharia e arquitetura para cada etapa do seu projeto imobiliário.
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 flex flex-col gap-20">
          {SERVICES_DETAILED.map((service, i) => (
            <div key={service.title} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "lg:grid-flow-col-dense" : ""}`}>
              {/* Image */}
              <div className={`rounded-2xl overflow-hidden ${i % 2 === 1 ? "lg:col-start-2" : ""}`}>
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-[350px] object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className={i % 2 === 1 ? "lg:col-start-1 lg:row-start-1" : ""}>
                <div className="w-14 h-14 flex items-center justify-center rounded-xl mb-5" style={{ backgroundColor: "#2563EB15" }}>
                  <i className={`${service.icon} text-3xl`} style={{ color: "#2563EB" }} />
                </div>
                <h2 className="text-[#1F1F1F] font-bold text-3xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  {service.title}
                </h2>
                <div className="w-12 h-1 bg-[#C9A24A] mb-5" />
                <p className="text-[#7A7A7A] text-[15px] leading-relaxed mb-6">{service.desc}</p>
                <div className="grid grid-cols-2 gap-2 mb-7">
                  {service.items.map((item) => (
                    <div key={item} className="flex items-center gap-2 text-[#1F1F1F] text-sm">
                      <i className="ri-check-line text-[#2563EB]" />
                      {item}
                    </div>
                  ))}
                </div>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1E3A8A] text-white font-semibold px-7 py-3 rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm"
                >
                  <i className="ri-whatsapp-line" />
                  Solicitar Orçamento
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Process */}
      <section className="py-24" style={{ backgroundColor: "#1E3A8A" }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-[#C9A24A] text-xs font-semibold tracking-widest uppercase mb-3 block">Como trabalhamos</span>
            <h2 className="text-white font-bold text-4xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Nosso Processo
            </h2>
            <div className="w-16 h-1 mx-auto bg-[#C9A24A]" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {PROCESS.map((step) => (
              <div key={step.step} className="bg-white/10 border border-white/20 rounded-xl p-7 text-center hover:bg-white/15 transition-all">
                <div className="text-[#C9A24A] font-bold text-5xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  {step.step}
                </div>
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-white/10">
                  <i className={`${step.icon} text-white text-2xl`} />
                </div>
                <h3 className="text-white font-bold text-xl mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>{step.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ backgroundColor: "#121212" }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-white font-bold text-4xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Qual serviço você precisa?
          </h2>
          <p className="text-white/70 text-lg mb-8">Fale conosco e receba uma consultoria personalizada sem compromisso.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-[#C9A24A] hover:bg-[#b8902f] text-[#121212] font-bold px-8 py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line" /> Falar no WhatsApp
            </a>
            <a
              href="mailto:construlifeprojetos@gmail.com"
              className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#121212] font-semibold px-8 py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line" /> Enviar E-mail
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
